import {
  ADMIN_FEES_PERCENT_MIN,
  ADMIN_FEES_PERCENT_MAX,
  ATTENDEE_LIMIT,
} from './event.constants';

export const ADMIN_FEES_PERCENT_MIN_MAX = `Each admin fee must be a number between ${ADMIN_FEES_PERCENT_MIN}-${ADMIN_FEES_PERCENT_MAX}.`;
export const ADMIN_FEES_SUM_MIN_MAX = `The sum of admin fees percents must be between ${ADMIN_FEES_PERCENT_MIN}-${ADMIN_FEES_PERCENT_MAX}%.`;
export const BLIND_STRUCTURE_MIN_MAX =
  'Each blind level must have a small blind, big blind, ante, and duration greater than 0.';
export const ATTENDEE_MAX = `Cannot have more than ${ATTENDEE_LIMIT} attendees for an event.`;
export const EVENT_REQUIRED = 'No Event. Event is required';
export const EVENT_NOT_FOUND = (eventId: string) =>
  `No event with id ${eventId}`;
export const GET_EVENT = (eventId: string) => `Error getting event ${eventId}`;
export const SET_ATTENDEE_LIMIT = `Cannot add more than ${ATTENDEE_LIMIT} attendees at once.`;
